import { sanitizeUrl } from '@braintree/sanitize-url';
import { getColorValue } from '@loomhq/lens';
import React from 'react';
import { connect } from 'react-redux';

import { VIDEO_CTA_CLICKED } from 'constants/events';
import * as analytics from 'utilities/analytics';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import { EXPERIMENT_RENAME_CTA } from '../../../../../shared/constants/featureFlag';

import './styles.less';

const CustomCtaButton = props => {
  const { ctaMods, ctaUrl, ctaText, onClickHandler } = props;

  let color;
  let background_color;
  let border_radius;

  if (ctaMods) {
    color = ctaMods.color;
    background_color = ctaMods.background_color;
    border_radius = ctaMods.border_radius;
  }

  color = color || getColorValue('white');
  background_color = background_color || getColorValue('orange');

  const renameCTAFlag = useFeatureFlagValue(EXPERIMENT_RENAME_CTA);

  const fallbackText = renameCTAFlag ? 'Link text' : 'Call-to-action';

  const hasText = ctaText && ctaText.length > 0;
  const hasUrl = ctaUrl && ctaUrl.length > 0;

  // Link cannot be clicked until text & url are at least partially entered
  const linkProperties =
    hasText && hasUrl
      ? {
          href:
            ctaUrl && (ctaUrl.indexOf('http') > -1 ? ctaUrl : `//${ctaUrl}`),
        }
      : {};

  return (
    <a
      className="cta-button"
      target={ctaUrl && '_blank'}
      rel="noopener noreferrer"
      onClick={onClickHandler}
      style={{
        color,
        backgroundColor: background_color,
        borderRadius: `${border_radius}px`,
      }}
      size={ctaText ? ctaText.length : 0}
      {...linkProperties}
    >
      {hasText ? (
        ctaText
      ) : (
        <span className="call-to-action-placeholder">{fallbackText}</span>
      )}
    </a>
  );
};

const mapStateToProps = (state, props) => {
  const {
    cta_mods: ctaMods,
    cta_text: ctaText,
    cta_url: ctaUrl,
  } = state.share_video;

  const {
    from_public_share_page,
    is_inline_embed_on_loom,
    parent_location,
    video,
  } = state.video_player;

  const { id, owner_id } = video || {};
  const {
    current: { id: viewerId },
  } = state.user;

  return {
    ctaMods,
    ctaText,
    ctaUrl: sanitizeUrl(ctaUrl),
    onClickHandler: () => {
      const { onClick } = props;

      onClick && onClick();

      analytics.track(VIDEO_CTA_CLICKED, {
        from_public_share_page,
        is_inline_embed_on_loom,
        parent_location,
        video_id: id,
        owner_id,
        owner_click: owner_id === viewerId,
      });
    },
  };
};

export default connect(mapStateToProps)(CustomCtaButton);
